const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

window.addEventListener('scroll', function () {
  const track = document.querySelector('.track');
  const tub = document.querySelector('.tub');
  const foliage = document.querySelector('.foliage');
  const fog = document.querySelector('.fog');
  const camera = document.querySelector('.camera');

  const trackHeight = track.offsetHeight;
  const scrollPos = window.scrollY;

  // Calculate scroll percentage relative to the track height
  const scrollPercent = (scrollPos / trackHeight) * 100;

  // Tub scaling logic (same as before)
  if (scrollPercent >= 0) {
    /*let tubScale = 1;
  
    if (scrollPercent <= 15) { // Adjusted to match the first range (0 to 15%)
      tubScale = 1 + (scrollPercent / 15) * 0.4; // 1 to 1.4
    } else if (scrollPercent > 15) { // Adjusted second range (15 to 52%)
      tubScale = 1.4 + ((scrollPercent - 15) / (52 - 15)) * 0.2; // 1.4 to 1.6
    }

    tub.style.transform = `scale(${tubScale}, ${tubScale})`;

    // Foliage scaling logic
    let foliageScale = 1;

    if (scrollPercent <= 12) { // Adjusted to match the first range (0 to 12%)
      foliageScale = 1 + (scrollPercent / 12) * 0.5; // 1 to 1.5
    } else if (scrollPercent > 12 && scrollPercent <= 32) { // Adjusted second range (12 to 32%)
      foliageScale = 1.5 + ((scrollPercent - 12) / (32 - 12)) * 0.1; // 1.5 to 1.6
    } else if (scrollPercent > 32) {
      foliageScale = 1.6 + ((scrollPercent - 32) / (72 - 32)) * 0.1; // 1.6 to 1.7
    } */

    // Foliage movement logic
    let moveY = 0;
    let foliageScale = 1; // delete this if reintroducing scaling
    
    if (scrollPercent >= 60) {
      moveY = ((scrollPercent - 60) / (100 - 60)) * -400; // Interpolate between 0px and -400px
    }

    foliage.style.transform = `scale(${foliageScale}, ${foliageScale}) translate(0px, ${moveY}px)`;

    // Fog scaling logic
    /*let fogScale = 1;

    if (scrollPercent <= 12) {
      fogScale = 1 + ((scrollPercent) / (12)) * 0.5; // 1 to 1.5
    } else if (scrollPercent > 12) {
      fogScale = 1.5 + ((scrollPercent - 12) / (72 - 12)) * 0.2; // 1.5 to 1.7
    }

    fog.style.transform = `scale(${fogScale}, ${fogScale})`;*/

  } /*else {
    // Lock scales at maximum after respective scroll points
    tub.style.transform = 'scale(1.6, 1.6)';
    foliage.style.transform = 'scale(1.7, 1.7)';
    fog.style.transform = 'scale(1.7, 1.7)';
  }*/

  // Fog opacity logic
  if (scrollPercent >= 0 && scrollPercent <= 16) {
    let fogOpacity = 0.5 - (scrollPercent / 16) * 0.4; // 0.5 to 0.1
    fog.style.opacity = fogOpacity;
  } else if (scrollPercent > 16) {
    fog.style.opacity = '0.1';
  } else {
    fog.style.opacity = '0.5'; // Reset before 0%
  }

  // Camera opacity logic
  if (scrollPercent >= 65 && scrollPercent <= 85) {
    let cameraOpacity = 1 - ((scrollPercent - 65) / (85 - 65)); // 1 to 0
    camera.style.opacity = cameraOpacity;
  } else if (scrollPercent > 85) {
    camera.style.opacity = '0';
  } else if (scrollPercent < 65) {
    camera.style.opacity = '1'; // Reset before 70%
  }
});

const preloader = () => {
  const preWrapper = document.querySelector('.preloader');
  const preItems = document.querySelector('.items');
  const progress = document.querySelector('.bar')

  preWrapper.style.opacity = 1;
  preWrapper.style.transform = 'translate(0, 0)';
  preWrapper.style.display = 'block';

  progress.style.width = '100%';

  setTimeout(() => {
    preWrapper.style.opacity = 0;
    preWrapper.style.transform = 'translate(0, -100%)';

    preWrapper.addEventListener('transitionend', () => {
      preWrapper.style.display = 'none';
    }, { once: true });

  }, 800);

}

window.addEventListener('load', preloader);
